import * as React from "react";
import { memo } from "react";
import styled from "styled-components";
import { mobile } from "../../../../ui/_themes/constants";
import { getColor, getTextShadow } from "../../../../ui/_themes/helpers";

export interface IDisplayMobileProps {
  dataE2EId: string;
  textAlign?: string;
  className?: string;
  label: string;
  value: string;
  childValue?: string;
  isCash?: boolean;
}

const calculateFontSize = (str: string) => {
  if (!str || str.length <= 11) {
    return "0.8em";
  } else if (str.length <= 13) {
    return "0.7em";
  } else if (str.length <= 15) {
    return "0.6em";
  } else if (str.length <= 17) {
    return "0.5em";
  } else {
    return "0.4em";
  }
};

export const View = ({
  className,
  label,
  value,
  childValue,
  dataE2EId,
  isCash
}) => {
  const showChild = typeof childValue !== "undefined" && !isCash;

  return (
    <div className={className}>
      <div>
        <span data-e2e-id={`${dataE2EId}-label`}>{label}</span>
      </div>
      <div>
        <span data-e2e-id={`${dataE2EId}-value`}>{value}</span>
        {showChild && (
          <span data-e2e-id={`${dataE2EId}-secondary-value`}>{childValue}</span>
        )}
      </div>
    </div>
  );
};

export const DisplayMobile = memo(styled(View)`
  display: flex;
  flex-direction: column;
  color: ${getColor("displaysValue", "displays.value")};
  text-align: ${({ textAlign = "center" }) => textAlign};
  overflow-x: hidden;

  > div:nth-child(1) {
    width: 100%;

    > span {
      display: block;
      color: ${getColor("displays")};
      font-size: ${mobile.fontSize.xs};
      font-weight: 400;
      white-space: nowrap;
      letter-spacing: 0.1em;
      text-shadow: ${getTextShadow("displaysTitle", "displays.title")};
    }
  }

  > div:nth-child(2) {
    > span {
      white-space: nowrap;
      display: block;

      &:nth-child(1) {
        font-size: ${props => calculateFontSize(props.value)};
        font-weight: 700;
        letter-spacing: 0.04em;
      }

      &:nth-child(2) {
        font-size: ${mobile.fontSize.xs};
      }
    }
  }

  @media (orientation: portrait) {
    flex: 0 0 33%;
  }

  @media (orientation: landscape) {
    flex: 1 1 20%;
  }
`);

export const DisplayWrapperPortrait = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 0.8em;
  margin-bottom: 0.2em;

  @media (orientation: portrait) {
    > div {
      flex: 1 1 100%;
      overflow: hidden;
      flex-direction: row;

      > div:nth-child(1) {
        margin-right: 0.3em;
        width: auto;
      }

      > div:nth-child(1) > span {
        &:after {
          content: ":";
        }
      }

      &:nth-of-type(2) {
        font-weight: 700;
      }

      > div:nth-child(1) > span,
      > div:nth-child(2) > span:nth-child(1) {
        font-size: ${mobile.fontSize.xs};
        letter-spacing: 0.1em;
        margin: 0;
        display: block;
      }

      &:only-child {
        width: 100%;
        line-height: 1;
        justify-content: center;

        > div > span,
        > div:nth-child(2) > span {
          font-size: 0.8em;
          letter-spacing: 0.04em;
        }
      }

      &:nth-of-type(2) {
        justify-content: flex-end;
        margin-left: 1.2em;
      }
    }
  }

  @media (orientation: landscape) {
    display: none;
  }
`;

export const DisplayWrapperLandscape = styled.div`
  @media (orientation: portrait) {
    display: none;
  }

  @media (orientation: landscape) {
    flex: 1 1 15%;
    overflow-x: hidden;
  }
`;
